import { supabase } from "../supabase/SupabaseClient";
import { actual } from "./quien";

/* El catálogo de alertas: qué avisa el sistema, a quién y cuándo.
 *
 * La tabla `alertas` es un CATÁLOGO, no un motor: cada alerta que el bot
 * manda tiene acá su fila con nombre, cadencia y destinos. Las que figuran
 * `editable = true` leen sus destinos y su encendido DE LA TABLA (módulo
 * `alertas_config` de FlotaBot), así que cambiarlas acá rige sin deploy.
 * Las demás muestran sus valores reales pero los gobierna el código del
 * bot — se van migrando de a una.
 *
 * Las llaves las pone la RLS: ver pide `ver.sistema`, tocar pide
 * `admin.permisos`. La pantalla sólo refleja esa pared.
 */

export async function traerAlertas() {
  const { data, error } = await supabase
    .from("alertas")
    .select("clave,nombre,descripcion,cadencia,destinos,activa,editable,dias,hora_desde,hora_hasta,actualizado_por,actualizado_en")
    .order("editable", { ascending: false })
    .order("nombre");
  if (error) throw error;
  return data || [];
}

/* Destinos, encendido y agenda (días + franja horaria). El resto de la fila lo
 * describe el código. `dias` son dígitos ISO (1=Lun … 7=Dom); vacío = todos.
 * `hora_desde`/`hora_hasta` en null = todo el día. */
export async function guardarAlerta(
  clave,
  { destinos, activa, dias, hora_desde, hora_hasta }
) {
  const cambios = { actualizado_en: new Date().toISOString() };
  if (destinos !== undefined) cambios.destinos = destinos;
  if (activa !== undefined) cambios.activa = activa;
  if (dias !== undefined) cambios.dias = dias;
  if (hora_desde !== undefined) cambios.hora_desde = hora_desde;
  if (hora_hasta !== undefined) cambios.hora_hasta = hora_hasta;
  const quien = actual();
  if (quien?.mail) cambios.actualizado_por = quien.mail;
  const { data, error } = await supabase
    .from("alertas")
    .update(cambios)
    .eq("clave", clave)
    .eq("editable", true)
    .select()
    .single();
  if (error) throw error;
  return data;
}
